import { UiIcon } from 'znanie-uikit';

import { ContentTypeEnum } from 'graphql/types';

import css from './ContentTypeIcon.module.scss';

interface IProps {
  type?: string;
}

const ContentTypeIcon = ({ type }: IProps) => {
  const getTypeIcon = (type?: string) => {
    switch (type) {
      case ContentTypeEnum.Video:
        return 'movie-play';
      case ContentTypeEnum.Article:
        return 'list';
      default:
        return '';
    }
  };

  return (
    <div className={css.icon}>
      <UiIcon name={getTypeIcon(type)} size={16} />
    </div>
  );
};

export default ContentTypeIcon;
